import React from "react";
import PropTypes from "prop-types";

export const SignatureComponent = ({
  signatureComponent,
  onChangeSignatureName,
  typePadDisplay,
  btnDrawStyle,
  onHiddenType,
  btnTypeStyle,
  onHiddenSigPad,
  clearSignature,
  sigPadDisplay,
  signatureName,
}) => {
  return (
    <div className="signatureComponent">
      <div className="btn-div">
        <p>
          <button
            type="button"
            className={` btn ${btnDrawStyle} btn-draw `}
            onClick={onHiddenType}
          >
            Draw
          </button>{" "}
          <button
            type="button"
            className={`btn ${btnTypeStyle} btn-type`}
            onClick={onHiddenSigPad}
          >
            Type
          </button>{" "}
          <button
            type="button"
            className="btn btn-danger btn-clear"
            onClick={clearSignature}
          >
            Clear
          </button>
        </p>
      </div>

      <div className="sigPad signature" style={{ display: sigPadDisplay }}>
        {signatureComponent}
      </div>
      <div style={{ display: typePadDisplay }}>
        <input
          className="form-control input-sign"
          name="signatureName"
          value={signatureName}
          onChange={onChangeSignatureName}
          placeholder="First and Last Name"
        />
      </div>
      <br />
      <div className={"signature"} style={{ display: typePadDisplay }}>
        <canvas id="typeCanvas" width="430" height="125">
          Your browser does not support the canvas element.
        </canvas>
      </div>
    </div>
  );
};

/** Allowed Props */
SignatureComponent.propTypes = {
  onChangeSignatureName: PropTypes.func.isRequired,
  onHiddenSigPad: PropTypes.func.isRequired,
  onHiddenType: PropTypes.func.isRequired,
  clearSignature: PropTypes.func.isRequired,
};

/** Specifies the default values for props: */
SignatureComponent.defaultProps = {
  signatureName: "",
  typePadDisplay: "none",
  sigPadDisplay: "block",
  btnTypeStyle: "btn-default",
  btnDrawStyle: "btn-success",
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/component/SignatureComponent.js